import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {articleIndexRoute} from '../../../constants/public-routes';
import TocEl from '../components/TocEl';
import printModule from '../../print';
import {LANGUAGES} from '../../../constants/dia';

let {PrintButtons} = printModule.components;

class StructureTOC extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    let {toc, structure} = this.props;
    return (
      <div className="toc">
        {toc.map((el, i) => {
          let ids = [];
          if (el.type !== 'articles') {
            ids = [el.id];
            let index = i + 1;
            while (index < toc.length) {
              if (toc[index].type !== 'articles') {
                if (toc[index].level <= el.level) {
                  index = toc.length;
                  continue;
                }
                ids.push(toc[index].id);
              }
              else {
                ids = ids.concat(toc[index].articles.map(art => {
                  return art.id;
                }));
              }
              index++;
            }
          }
          return (<TocEl key={i} el={el}><PrintButtons className="text-muted" ids={ids} label={el.body + ' (' + structure.item.attributes.label + ')'}/></TocEl>);
        })}
      </div>
    );
  }
}

StructureTOC.propTypes = {
  toc: PropTypes.array.isRequired,
  structure: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  const {structure, intl} = state;
  const toc = tocToList(structure.item.attributes.toc, intl.locale, structure.item.id) || [];
  return {
    structure,
    toc,
    intl
  };
}

function tocToList(root, language, structureId) {
  let languageOrder = JSON.parse(JSON.stringify(LANGUAGES));
  languageOrder.splice(languageOrder.indexOf(language), 1);
  languageOrder = [language].concat(languageOrder);
  // TODO to selectors
  return elToList(root, 0).slice(1);

  function getBody(el) {
    for (let lang of languageOrder) {
      if (el['body_' + lang]) {
        return el['body_' + lang];
      }
    }

    return el.label;
  }

  function elToList(el, level) {
    let list = [];
    let {children, label, type, id} = el;

    list.push({label, body: getBody(el), type, level, id});
    let articles = [];
    for (let i = 0; i < children.length; i++) {
      if (children[i].type === 'article') {
        articles.push({
          label: children[i].label,
          body: getBody(children[i]),
          type: 'article',
          id: children[i].article_id,
          url: articleIndexRoute(language, structureId, children[i].article_id)
        });
      }
      else {
        if (articles.length > 0) {
          list.push({type: 'articles', level: level, articles});
        }
        articles = [];
        list = list.concat(elToList(children[i], level + 1));
      }
    }
    if (articles.length > 0) {
      list.push({type: 'articles', level: level, articles});
    }
    return list;
  }
}


export default connect(mapStateToProps)(StructureTOC);



/** WEBPACK FOOTER **
 ** ./src/modules/structures/containers/StructureTOC.js
 **/